import { Button } from '@panwds/react-ui'


export interface UTileProps {
  product_image: any;
  product_title: string;
  subtitle?: string;
  action: () => void;
  action_text: string;
  product_attributes?: { [key: string]: string; }
}
const UTile = (props: UTileProps) => {
  const attributes = Object.keys(props.product_attributes || {})
  return (
    <div className="cm-flex cm-border-solid cm-border cm-rounded-md cm-mb-3 cm-p-4 cm-border-[#DADBDB] dark:cm-border-[#242424] hover:cm-border-[#38A5FF]' style={{ maxWidth: '1248px' }}">
      <div className="cm-flex-none cm-flex ">
        <img src={props.product_image} alt={props.product_title} width={40} height={40} />
      </div>
      <div className="cm-flex-auto cm-w-3/5 cm-pl-5">
        <span>{props.product_title}</span>
        <span><h2>{props.subtitle}</h2></span>
        {attributes?.map((a, index) => (props.product_attributes && (<span key={index}><b>{a}:</b> {props.product_attributes[a]}</span>)))}
      </div>
      <div className="cm-flex-none cm-w-32">
        <Button appearance='primary' onClick={props.action}>{props.action_text}</Button>
      </div>
    </div>
  )
}

export default UTile
